<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_261" data-name="Rectangle 261" width="24" height="24" transform="translate(186 18)" fill="#fff"/>
    </clipPath>
  </defs>
  <g id="Mask_Group_38" data-name="Mask Group 38" transform="translate(-186 -18)" clip-path="url(#clip-path)">
    <g id="Group_2505" data-name="Group 2505" transform="translate(189.809 20.561)">
      <path id="Path_1252" class="stroke-change" data-name="Path 1252" d="M152.826,109.913c-2.267,0-5.43-1.216-8.473-4.259-3.9-3.9-4.8-7.994-3.984-10.15a3.908,3.908,0,0,1,3.12-2.208,1.329,1.329,0,0,1,1.422.723l1.421,2.921a1.328,1.328,0,0,1-.3,1.556l-1.209,1.1c.048.39.348,1.6,2.171,3.418s3.019,2.12,3.419,2.17l1.1-1.207a1.329,1.329,0,0,1,1.556-.3l2.921,1.421a1.328,1.328,0,0,1,.723,1.422,3.908,3.908,0,0,1-2.208,3.119,4.768,4.768,0,0,1-1.677.275Z" transform="translate(-140.094 -92.138)" fill="none" stroke="#fff" stroke-width="1.4"/>
    </g>
  </g>
</svg>
